import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("mb_token");
    if (!t) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("mb_token"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleAuthExpired = () => {
      localStorage.removeItem("mb_token");
      setUser(null);
      setLoading(false);
    };
    window.addEventListener("mb:auth-expired", handleAuthExpired);
    return () => window.removeEventListener("mb:auth-expired", handleAuthExpired);
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("mb_token", r.data.access_token);
    setUser(r.data.user);
    return r.data.user;
  };
  const updateProfile = async (payload) => {
    const r = await api.put("/auth/me", payload);
    setUser(r.data);
    return r.data;
  };
  const logout = () => {
    localStorage.removeItem("mb_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout, updateProfile }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
